<script>
import { pollingListAvailableGroups } from 'api/index'
const DEFAULT_AVATAR =
  '//img.winbaoxian.com/static/images/exam/bxs_default_logoImg.png'
export default {
  name: 'InterpretationNotice',
  data() {
    return {
      isShow: false,
      customer: {}
    }
  },
  computed: {
    avatarImg() {
      const { customer } = this
      return customer && customer.headimgurl
        ? `${customer.headimgurl}?x-oss-process=image/resize,m_mfit,h_64,w_64`
        : DEFAULT_AVATAR
    }
  },
  watch: {},
  created() {
    const vm = this
    // 是否需要轮询
    this.interactionPollingOn = true
    function timer() {
      if (!vm.interactionPollingOn) return
      vm.fetchData()
      setTimeout(timer, 10000)
    }
    timer()
  },
  methods: {
    fetchData() {
      pollingListAvailableGroups()
        .then(({ data: { success, data } } = { data: {} }) => {
          if (!success || !data) {
            this.isShow = false
            this.interactionPollingOn = false
            return
          }
          const { interactionPollingOn, needInteractionClientDTOS } = data
          this.interactionPollingOn = interactionPollingOn
          if (
            !Array.isArray(needInteractionClientDTOS) ||
            !needInteractionClientDTOS[0] ||
            !needInteractionClientDTOS[0].pbUuid ||
            !needInteractionClientDTOS[0].groupId
          ) {
            this.isShow = false
          } else {
            this.customer = needInteractionClientDTOS[0]
            this.isShow = true
          }
        })
        .catch(() => {
          this.isShow = false
        })
    },
    toPbInterpretation() {
      const {
        customer: { pbUuid, groupId, theme }
      } = this
      this.isShow = false
      let toPbUrl = `${location.origin}${location.pathname}?nw=1&uuid=${pbUuid}&roomId=${groupId}`
      if (theme) toPbUrl += `theme=${theme}`
      location.href = toPbUrl
    }
  }
}
</script>
<template>
  <transition name="slide-fade">
    <div
      v-if="isShow"
      class="interpretation-notice"
      @click="toPbInterpretation"
    >
      <p>等待讲解...</p>
      <div class="avatar">
        <img :src="avatarImg" :alt="customer.nickname">
      </div>
      <div>
        <div class="btn">
          <span>去讲解</span>
        </div>
      </div>
    </div>
  </transition>
</template>
<style scoped>
.interpretation-notice {
  z-index: 10;
  position: fixed;
  right: 5px;
  bottom: 94px;
  width: 56px;
  padding: 6px 8px;
  border-radius: 9px;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: 12px;
  text-align: center;
  > p {
    color: #f6da80;
    margin-bottom: 3px;
    white-space: nowrap;
    transform: scale(0.67);
    transform-origin: left center;
  }
  .avatar {
    display: inline-block;
    overflow: hidden;
    width: 32px;
    height: 32px;
    margin-bottom: 3px;
    border: 1px solid #fff;
    border-radius: 100rem;
    > img {
      width: 100%;
      border-radius: 100rem;
    }
  }
  .btn {
    display: inline-block;
    padding: 2px;
    border-radius: 15px;
    color: #fff;
    background: linear-gradient(to right, #ff7e00, #ff505d);
    > span {
      display: block;
      transform: scale(0.67);
      transform-origin: center;
    }
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
